import swiper from 'swiper';



var heroMain = new swiper ('.js-top-hero-slider', {
  direction: 'horizontal',
  loop: true,
  effect: "fade",
  speed:1000,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  observer: true,
  preloadImages: true,
  autoHeight: true,
  lazy: {
    loadPrevNext: true,
    loadPrevNextAmount: 2
  },
  watchSlidesProgress: true,
  pagination: {
    el: '.swiper-pagination',
    type: 'fraction',
  },
  navigation: {
    nextEl: '.top-hero-slider__nav-button.is-next',
    prevEl: '.top-hero-slider__nav-button.is-prev',
  },
  on: {
    init: function () {
      $(".js-top-hero-slider .swiper-slide[data-swiper-slide-index=" + (this.realIndex) + "]").addClass('is-active');
      $('.top-hero-slider__caption').text($(".js-top-hero-slider .swiper-slide[data-swiper-slide-index=" + (this.realIndex) + "] img").data('caption'));
    }
  }
});

heroMain.on('slideChangeTransitionStart', function(){
  $('.top-hero-slider__caption').text($(".js-top-hero-slider .swiper-slide[data-swiper-slide-index=" + (heroMain.realIndex) + "] img").data('caption'));
});
heroMain.on('slideChangeTransitionEnd', function(){
  $('.top-hero-slider__caption').text($(".js-top-hero-slider .swiper-slide[data-swiper-slide-index=" + (heroMain.realIndex) + "] img").data('caption'));

});



// console.log(swiper)
